@if (form) {
  <form [formGroup]="form">
    <mat-toolbar color="accent">
      <mat-toolbar-row>
        <button mat-button (click)="onClose()">
          <mat-icon aria-hidden="false" aria-label="Close">close</mat-icon>
          Close
        </button>
        <span class="toolbar-spacer"></span>
        <button mat-button [disabled]="!form.dirty" (click)="onReset()">
          <mat-icon aria-hidden="false" aria-label="Cancel">cancel</mat-icon>
          Cancel
        </button>
        <button mat-button [disabled]="!form.dirty" (click)="onSave()">
          <mat-icon aria-hidden="false" aria-label="Save">save</mat-icon> Save
        </button>
      </mat-toolbar-row>
    </mat-toolbar>
    <div class="sections">
      <section>
        <mat-form-field appearance="outline">
          <mat-label>ID</mat-label>
          <input matInput formControlName="id" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>External ID</mat-label>
          <input matInput formControlName="externalId" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Division</mat-label>
          <mat-select formControlName="divisionType">
            @for (divisionType of divisionTypes; track divisionType) {
              <mat-option [value]="divisionType">
                {{ divisionType }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Origin</mat-label>
          <mat-select formControlName="originType">
            @for (originType of originTypes; track originType) {
              <mat-option [value]="originType">
                {{ originType }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Completion System</mat-label>
          <mat-select formControlName="completionType">
            <mat-option [value]="''"> None </mat-option>
            @for (completionSystem of completionSystems; track completionSystem) {
              <mat-option [value]="completionSystem">
                {{ completionSystem }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Progress cut-off day</mat-label>
          <mat-select formControlName="progressCutOffDay">
            <mat-option [value]="null"> None </mat-option>
            @for (day of progressCutOffDay; track day) {
              <mat-option [value]="progressCutOffDay.indexOf(day) + 1">
                {{ day }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <input matInput formControlName="progressCutOffTime" placeholder="HH:MM:SS" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Job-card feedback recipient email</mat-label>
          <input matInput type="email" formControlName="jobFeedbackRecipientEmail" />
          <mat-error *ngIf="form.get('jobFeedbackRecipientEmail')?.hasError('email')">
            Enter a valid email address
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Weight-change report recipient email</mat-label>
          <input matInput type="email" formControlName="weightChangeRecipientEmail" />
          <mat-error *ngIf="form.get('weightChangeRecipientEmail')?.hasError('email')">
            Enter a valid email address
          </mat-error>
        </mat-form-field>
      </section>
    </div>
  </form>
} @else {
  Loading project...
}
